import { SimpleRegistration, SimpleRegistrationErrors } from '../types';

export const validateSimpleRegistration = (formData: Partial<SimpleRegistration>): SimpleRegistrationErrors => {
  const errors: SimpleRegistrationErrors = {};

  // Validar email
  if (!formData.email?.trim()) {
    errors.email = 'El email es requerido';
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    errors.email = 'El email no es válido';
  }

  // Validar contraseña
  if (!formData.password?.trim()) {
    errors.password = 'La contraseña es requerida';
  } else if (formData.password.length < 3) {
    errors.password = 'La contraseña debe tener al menos 3 caracteres';
  }

  // Validar confirmación de contraseña
  if (!formData.confirmPassword?.trim()) {
    errors.confirmPassword = 'Confirma tu contraseña';
  } else if (formData.password !== formData.confirmPassword) {
    errors.confirmPassword = 'Las contraseñas no coinciden';
  }

  // Validar nombre completo
  if (!formData.fullName?.trim()) {
    errors.fullName = 'El nombre completo es requerido';
  } else if (formData.fullName.trim().length < 2) {
    errors.fullName = 'El nombre debe tener al menos 2 caracteres';
  }

  return errors;
};
